<sc-chat
  *ngIf="sidebar?.open && sidebar?.appearance === 'chat'"
  (closeSidebar)="closeSidebar()"
  [chatGroupID]="sidebar?.metadata?.chatGroupID"
  [sidebarIndex]="sidebarIndex"></sc-chat>

<sc-participants *ngIf="sidebar?.appearance === 'participants'" (closeSidebar)="closeSidebar()"></sc-participants>

<sc-recordings
  *ngIf="sidebar?.open && sidebar?.appearance === 'recordings'"
  (closeSidebar)="closeSidebar()"></sc-recordings>

<sc-name-menu
  *ngIf="sidebar?.open && sidebar?.appearance === 'settings'"
  (closeSidebar)="closeSidebar()"></sc-name-menu>

<sc-stats-for-nerds
  *ngIf="session$?.value?.confType !== 'daily' && sidebar?.open && sidebar?.appearance === 'stats'"
  [participantID]="sidebar.metadata?.participantID"
  appearance="sidebar"
  (closeSidebar)="closeSidebar()">
</sc-stats-for-nerds>
